export default __webpack_public_path__ + "static/media/job_offer1_xl.6399cca3.jpg";